import React from 'react';
import { Link } from 'gatsby';

import Modal from 'react-bootstrap/Modal';
import { Person, PersonFill } from 'react-bootstrap-icons';

import { SessionContext } from '../../context/sessioncontext';
import { MemberCard } from '../../components/members/card';
import { LogoutButton } from '../../components/account/logoutbutton';
import { slugifyHandle } from '../../utils/common';

import './menu.css';

const UserMenu = (props) => {
	const userSession = React.useContext(SessionContext);
	const [loggedIn, setLoggedIn] = React.useState(false);
	const [menuOpen, setMenuOpen] = React.useState(false);

	React.useEffect(() => {
		if (userSession.session !== '' && userSession.user)
			setLoggedIn(true);
		else
			setLoggedIn(false);
	}, [userSession]);

	return (
		<React.Fragment>
			{!loggedIn &&
				<Link to='/login/'>
					<Person className='actionicon' size='24' />
				</Link>
			}
			{loggedIn &&
				<React.Fragment>
					<Link to='/my/' onClick={(e) => triggerMenu(e)}>
						<PersonFill className='actionicon' size='24' />
					</Link>
					<Modal size='lg'
						show={menuOpen}
						onHide={() => setMenuOpen(false)}
						className='menu'
					>
						<Modal.Body>
							<div className='flexRow'>
								<MemberCard member={userSession.user} />
								{userSession.user.privileges?.includes('super', 'admin') &&
									<div>
										<ul>
											<li><Link to='/my/admin/'>Admin</Link></li>
										</ul>
									</div>
								}
								<div>
									<ul>
										<li><Link to='/my/'>My Tower Landing</Link></li>
										<li><Link to='/my/logins/'>Manage Logins</Link></li>
										<li><Link to='/my/profile/'>Edit Profile</Link></li>
										<li><Link to={`/members/${slugifyHandle(userSession.user.handle)}/`}>View Public Profile</Link></li>
									</ul>
									<div style={{ textAlign: 'center' }}>
										<LogoutButton />
									</div>
								</div>
							</div>
						</Modal.Body>
					</Modal>
				</React.Fragment>
			}
		</React.Fragment>
	);

	function triggerMenu(e) {
		setMenuOpen(true);
		e.stopPropagation();
		e.preventDefault();
		return false;
	}
}

export default UserMenu;
